
import { DEFAULTADDRESS, CITYCONTRACT, USERCONSTRUCT } from '../type'

let initState = {

  userWalletAddress: "",
  userConstruct: {}

};

export const UserReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {

    case DEFAULTADDRESS:
      return {
        ...state,
        userWalletAddress: payload
      }

    case CITYCONTRACT:
      return {
        ...state,
        contract: payload
      }
    case USERCONSTRUCT:

      return {
        ...state,
        userConstruct: payload
      }

    default:
      return state;
  }
};
